import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Veuillez compléter ces champs :", -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "form-group w-50" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Titre", -1)
const _hoisted_8 = { class: "form-group w-50" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "realisateur" }, "Réalisateur", -1)
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "year" }, "Année de sortie", -1)
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "imgUrl" }, "Affiche", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary my-3 col-2"
}, " Ajouter ", -1)
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h4", null, "Votre film a bien été enregistré !", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!_ctx.submitted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.checkForm && _ctx.checkForm(...args))),
            class: "mx-auto d-flex flex-column align-items-center"
          }, [
            (_ctx.errors.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: error.id
                      }, _toDisplayString(error), 1))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event)),
                  type: "text",
                  class: "form-control",
                  id: "inputTitle"
                }, null, 512), [
                  [_vModelText, _ctx.title]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.director) = $event)),
                  type: "string",
                  class: "form-control",
                  id: "inputRealisateur"
                }, null, 512), [
                  [_vModelText, _ctx.director]
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "form-control",
                  id: "inputYear",
                  min: "1000",
                  max: "9999",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.year) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.year]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.posterUrl) = $event)),
                  type: "string",
                  class: "form-control",
                  id: "inputImgUrl"
                }, null, 512), [
                  [_vModelText, _ctx.posterUrl]
                ])
              ])
            ]),
            _hoisted_14
          ], 32)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.newMovie && _ctx.newMovie(...args)))
          }, " Ajouter un nouveau film ? ")
        ]))
  ]))
}